<template>
  <div>
    <div class="footer-wrapper-2 ">
      <div class="container container-full-width text-center py-6">
        <div class="row align-items-center">
          <div class="col-sm-12 col-md-12 col-lg-12 mb-3">
            <div class="bottom-footer">
              <ul
                class="navbar-nav ml-auto main-menu list-unstyled"
                v-if="menus"
              >
                <li
                  @click="menuToggleLink('menuNo' + i)"
                  class="parent nav-item list-inline"
                  v-for="(menuItem, i) in menus"
                  :id="'menuNo' + i"
                  :key="i"
                >
                  <router-link
                    class="nav-link"
                    :to="menuItem.state"
                    v-if="menuItem.type == 'link'"
                    @click.native="removeCollapseInClass()"
                  >
                    {{ $t(menuItem.name) }}
                  </router-link>
                  <a v-if="menuItem.type == 'sub'" class="nav-link">
                    {{ $t(menuItem.name) }}&nbsp;
                    <i
                      :class="menuItem.icon"
                      @click.stop="menuToggle('menuNo' + i)"
                    ></i>
                  </a>
                  <ul
                    v-if="menuItem.type == 'sub' && menuItem.children"
                    class="sub-menu arrow-up list-unstyled"
                  >
                    <li
                      class="nav-item"
                      v-for="(grandchildItem, i) of menuItem.children"
                      :key="i"
                    >
                      <router-link
                        class="nav-link"
                        :to="grandchildItem.state"
                        v-if="grandchildItem.type == 'link'"
                        @click.native="removeCollapseInClass()"
                      >
                        <i :class="grandchildItem.icon"></i>
                        {{ $t(grandchildItem.name) }}
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="col-sm-12 col-md-12 col-lg-12 mb-4">
                  <div class="social-without-bg">
                     <ul class="list-inline mb-0">
                        <li class="list-inline-item"><a class="text-white" href="javascript:void(0)"><i class="fab fa-facebook-f"></i></a></li>
                        <li class="list-inline-item"><a class="text-white" href="javascript:void(0)"><i class="fab fa-twitter"></i></a></li>
                        <li class="list-inline-item"><a class="text-white" href="javascript:void(0)"><i class="fab fa-google-plus-g"></i></a></li>
                        <li class="list-inline-item"><a class="text-white" href="javascript:void(0)"><i class="fab fa-pinterest"></i></a></li>
                        <li class="list-inline-item"><a class="text-white" href="javascript:void(0)"><i class="fab fa-linkedin-in"></i></a></li>
                     </ul>
                  </div>
               </div> -->
          <div class="copright text-center col-sm-12 col-md-12 col-lg-12">
            <span class="text-white ">&copy; 2020, All Right Reserved </span>
          </div>
        </div>
      </div>
      <!-- container closed -->
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    CurrentLang() {
      return this.$i18n.locale;
    },
    appActiveUser() {
      return this.$store.state.AppActiveUser;
    },
  },
  components: {},
  data() {
    return {
      // showSubscriber: true,
      menus: [
        {
          state: "/home",
          name: "Home",
          type: "link",
        },
        {
          state: "",
          name: "Read & Listen",
          type: "sub",
          icon: "fa fa-caret-down",
          children: [
            {
              state: "books",
              name: "Books",
              type: "link",
              icon: "fa fa-book-open",
            },
            {
              state: "audios",
              name: "Audios",
              type: "link",
              icon: "fa fa-volume-up",
            },
            {
              state: "videos",
              name: "Videos",
              type: "link",
              icon: "fa fa-video",
            },
          ],
        },
        {
          state: "/blogs",
          name: "Blogs",
          type: "link",
        },
        {
          state: "/news",
          name: "News",
          type: "link",
        },
        {
          state: "/Favorites",
          name: "Favorite",
          type: "link",
        },
      ],
    };
  },
  methods: {
    getUrl() {
      let val = this.$route.path.split("/");
      if (val[1] == "home") {
        this.showSubscriber = false;
      } else {
        this.showSubscriber = true;
      }
    },
  },
  mounted() {
    this.getUrl();
  },
  watch: {
    $route() {
      this.getUrl();
    },
  },
};
</script>
